<template>
  <div class="statistical-page" ref="container">
    <div class="navs">
      <div class="list">
		<div
		  class="item"
		  :class="time == 'total' ? 'on' : ''"
		  @click="setTime('total')"
		>
		  全部
		</div>
        <div
          class="item"
          :class="time == 'today' ? 'on' : ''"
          @click="setTime('today')"
        >
          今天
        </div>
        <div
          class="item"
          :class="time == 'yesterday' ? 'on' : ''"
          @click="setTime('yesterday')"
        >
          昨天
        </div>
        <div
          class="item"
          :class="time == 'seven' ? 'on' : ''"
          @click="setTime('seven')"
        >
          最近7天
        </div>
        <!-- <div
          class="item"
          :class="time == 'month' ? 'on' : ''"
          @click="setTime('month')"
        >
          本月
        </div> -->
        <div
          class="item"
          :class="time == 'date' ? 'on' : ''"
          @click="dateTitle"
        >
          <!-- <span class="iconfont icon-xiangxia"></span>
          <span v-for="(value, index) in renderValues" :key="index">
            {{ value }}</span
          > -->
          自定义
        </div>
      </div>
    </div>
    <div class="calendar-wrapper" :class="current === true ? 'on' : ''">
      <div class="calendar">
        <Calendar
          :clean="clean"
          :lunar="lunar"
          ref="calendar"
          :range="isrange"
          :multi="ismulti"
          @select="select"
          @next="next"
          @prev="prev"
          :value="value"
          :weekSwitch="weekSwitch"
          :monthRange="monthRange"
          rangeMonthFormat="yyyy年MM月"
          monFirst
          responsive
          :begin="[1992, 5, 20]"
          :end="[2049, 5, 20]"
        />
      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      v-show="current === true"
      @click="close"
    ></div>
	<div v-if="inviteList.length > 0">
		<div class="total-ordernum">
			<p>
				共<strong>{{ total_invite }}</strong>个邀请
				<span @click="$router.push('/user/invite_order/total')">查看全部<i class="iconfont icon-jiantou"></i></span>
			</p>
			<p>获得邀请奖励<strong>{{ invitedCount }}</strong>元</p>
		</div>
		<div class="list invite-list">
			<div class="invite-item" v-for="(item,key) in inviteList" :key="key" @click="$router.push('/user/invite_order/total')">
			  <div class="pictrue">
				<img :src="item.avatar" />
			  </div>
			  <div class="text">
				<div class="name line1">{{ item.nickname }}</div>
				<p>我的邀请奖励：<strong>{{ item.invitedCount }}</strong></p>
				<p v-if="item.invalid_desc">{{ item.invalid_desc }}</p>
			  </div>
			  <div class="iconfont icon-jiantou right"></div>
			</div>
		</div>
	</div>
	<div v-else class="no-customer">
		<img src="@assets/images/no-customer.png" alt="">
		<p>暂无数据</p>
	</div>
	<Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import Calendar from "mpvue-calendar";
import "mpvue-calendar/src/browser-style.css";
import { getStatisticsMonth, getStatisticsTime } from "../../../api/admin";
const year = new Date().getFullYear();
const month = new Date().getMonth() + 1;
const day = new Date().getDate();
import { getSpreadUser } from "../../../api/user";
import Loading from "@components/Loading";
export default {
  name: "PromoterInvite",
  components: {
    Calendar,
	Loading
  },
  props: {},
  data: function() {
    return {
	  loaded: false,
	  loading: false,
      value: [[year, month, day - 1], [year, month, day]],
      isrange: true,
      weekSwitch: false,
      ismulti: false,
      monFirst: true,
      clean: false, //简洁模式
      lunar: false, //显示农历
      renderValues: [],
      monthRange: [],
      current: false,
      where: {
        start: "",
        stop: "",
        type: ""
      },
      time: "", //时间|today=今天|yesterday=昨天|month=本月
      title: "", //时间|today=今天|yesterday=昨天|month=本月
      total_invite: "",
	  invitedCount:"",
      screen: {
        page: 1,
        limit: 15,
        grade: 0,
        keyword: "",
      	type:2,
      	time:0
      },
	  inviteList:[]
    };
  },
  watch: {
    "$route.params": function(newVal) {
      var that = this;
      if (newVal != undefined) {
        that.setTime(newVal.time);
        that.getIndex();
      }
    }
  },
  mounted: function() {
    this.handelRenderValues();
    this.setTime(this.$route.params.time);
    this.getIndex();
	this.$scroll(this.$refs.container, () => {
	  !this.loading && this.getIndex();
	});
  },
  computed: {
    monthRangeText() {
      return this.monthRange.length ? "固定" : "指定范围";
    }
  },
  methods: {
    getIndex: function() {
      var that = this;
	  if (that.loaded || that.loading) return;
	  that.loading = true;
      getSpreadUser(that.screen).then(
        res => {
		  that.inviteList.push.apply(that.inviteList, res.data.list);
		  that.loading = false;
		  that.loaded = res.data.list.length < that.screen.limit; //判断所有数据是否加载完成；
		  that.screen.page = that.screen.page + 1;
		  that.total_invite = res.data.total;
		  that.invitedCount = res.data.invitedCount;
        },
        error => {
          that.$dialog.error(error.msg);
		  setTimeout(function(){
			that.$router.push('/');  
		  },1000);
        }
      );
    },
    setTime: function(time) {
	  let that = this;
      this.time = time;
      var year = new Date().getFullYear(),
        month = new Date().getMonth() + 1,
        day = new Date().getDate();
      switch (time) {
		case "total":
		  this.where.start =
		    new Date(Date.parse(2020 + "/" + 1 + "/" + 1)).getTime() /
		    1000;
		  this.where.stop =
		    new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
		      1000 +
		    24 * 60 * 60 -
		    1;
		  this.title = "全部";
		  that.screen.time = 0;
		  this.screen.page = 1;
		  this.loaded = false;
		  this.loading = false;
		  this.inviteList = [];
		  this.getIndex();
		  break;
        case "today":
          this.where.start =
            new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
            1000;
          this.where.stop =
            new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
              1000 +
            24 * 60 * 60 -
            1;
          this.title = "今日";
		  that.screen.time = "today";
		  this.screen.page = 1;
		  this.loaded = false;
		  this.loading = false;
		  this.inviteList = [];
          this.getIndex();
          break;
        case "yesterday":
          this.where.start =
            new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
              1000 -
            24 * 60 * 60;
          this.where.stop =
            new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
              1000 -
            1;
          this.title = "昨日";
		  that.screen.time = "yesterday";
		  this.screen.page = 1;
		  this.loaded = false;
		  this.loading = false;
		  this.inviteList = [];
          this.getIndex();
          break;
        // case "month":
        //   this.where.start =
        //     new Date(year, new Date().getMonth(), 1).getTime() / 1000;
        //   this.where.stop = new Date(year, month, 1).getTime() / 1000 - 1;
        //   this.title = "本月";
        //   this.getIndex();
        //   break;
        case "seven":
          this.where.start =
            new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
              1000 +
            24 * 60 * 60 -
            7 * 3600 * 24;
          this.where.stop =
            new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
              1000 +
            24 * 60 * 60 -
            1;
          this.title = "七日";
		  that.screen.time = "lately7";
		  this.screen.page = 1;
		  this.loaded = false;
		  this.loading = false;
		  this.inviteList = [];
          this.getIndex();
          break;
      }
    },
    clickSomeThing(data) {
      console.log(data);
      this.value = [[2019, 4, 1], [2019, 4, 8]];
    },
    setMonthRange() {
      this.monthRange = this.monthRange.length ? [] : ["2019-4", "2020-1"];
    },
    switchMode() {
      this.weekSwitch = !this.weekSwitch;
      setTimeout(() => {
        this.$refs.calendar.renderer(2019, 1); //渲染2018年8月份
      }, 0);
    },
    handelRenderValues(data) {
      if (this.ismulti) {
        this.renderValues = this.value.map(v => v.join("-"));
      } else if (this.isrange) {
        const values = [];
        data || this.value;
        this.value.forEach((v, i) => {
          values.push(v.join("-"));
          if (!i) {
            values.push("~");
          }
        });
        this.renderValues = values;
      } else {
        this.renderValues = [this.value.join("-")];
      }
    },
    multiMode() {
      this.ismulti = true;
      this.isrange = false;
      this.value = [[year, month, 16], [year, month, 18]];
      this.handelRenderValues();
      this.$refs.calendar.renderer(year, month);
    },
    rangeMode() {
      this.ismulti = false;
      this.isrange = true;
      this.value = [[year, month, 16], [year, month, 22]];
      this.handelRenderValues();
      this.$refs.calendar.renderer(year, month);
    },
    valueMode() {
      this.ismulti = false;
      this.isrange = false;
      this.value = [year, month, 16];
      this.handelRenderValues();
      this.$refs.calendar.renderer(year, month);
    },
    selectMonth(month, year) {
      console.log(year, month);
    },
    prev(y, m, w) {
      console.log(y, m, w);
    },
    next(year, month, week) {
      console.log(year, month, week);
    },
    selectYear(year) {
      console.log(year);
    },
    setToday() {
      this.$refs.calendar.setToday();
    },
    dateInfo() {
      const info = this.$refs.calendar.dateInfo(2018, 8, 23);
      console.log(info);
    },
    renderer() {
      if (this.monthRange.length) {
        this.monthRange = ["2018-8", "2018-8"];
      }
      this.$refs.calendar.renderer(2018, 8); //渲染2018年8月份
    },
    select(val, val2) {
      if (this.isrange) {
        this.handelRenderValues([val, val2]);
      } else if (this.ismulti) {
        this.handelRenderValues(val);
      } else {
        this.handelRenderValues([val]);
      }
      if (
        this.where.start != new Date(val) / 1000 ||
        this.where.stop != new Date(val2) / 1000 + 24 * 60 * 60 - 1
      ) {
        this.time = "date";
        this.title = "";
        this.where.start =
          new Date(Date.parse(val[0] + "/" + val[1] + "/" + val[2])).getTime() /
          1000;
        this.where.stop =
          new Date(
            Date.parse(val2[0] + "/" + val2[1] + "/" + val2[2])
          ).getTime() /
            1000 +
          24 * 60 * 60 -
          1;
		this.screen.time = val[0] + '-' + val[1] + '-' + val[2] + ' - ' + val2[0] + '-' + val2[1] + '-' + val2[2];
		this.screen.page = 1;
		this.loaded = false;
		this.loading = false;
		this.inviteList = [];
        this.getIndex();
      }
    },
    dateTitle: function() {
      this.current = true;
    },
    close: function() {
      this.current = false;
    },
    
  }
};
</script>
<style scoped>
.calendar-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 777;
  transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.calendar-wrapper.on {
  transform: translate3d(0, 0, 0);
}
.statistical-page .wrapper .increase {
  font-size: 0.26rem;
}
.statistical-page .wrapper .increase .iconfont {
  margin-left: 0;
}
.public-wrapper-mon{margin-top: 0.96rem;padding: 0.45rem 0.25rem;}
.statistical-page .navs{box-shadow: 0 0 5px #ccc;}
.public-wrapper-mon-top{border-bottom: 1px solid #ebedf0;padding-bottom: 0.3rem;}
.public-wrapper-mon-bot{display: flex;justify-content: center;}
.public-wrapper-mon-bot>div{width: 100%;padding-top: 0.2rem;}
.public-wrapper-mon-bot>div:last-child{border-left: 1px solid #ebedf0;padding-left: 0.2rem;}
.public-wrapper-mon-top h2,.public-wrapper-mon-bot h2,.public-wrapper-num h2{font-size: 0.38rem;}
.public-wrapper-mon-top .gray,.public-wrapper-mon-bot .gray,.public-wrapper-num .gray{color: #999;font-size: 0.26rem;margin-top: 0.1rem;}
.public-wrapper-mon-top .waitmon,.public-wrapper-mon-bot .waitmon{font-size: 0.26rem;margin-top: 0.1rem;}
.public-wrapper-num{margin-top: 0.2rem;padding: 0.45rem 0.25rem;display: flex;justify-content: center;}
.public-wrapper-num>div{width: 100%;}
.public-wrapper-num-l>div:first-child{border-bottom: 1px solid #ebedf0;padding-bottom: 0.2rem;}
.public-wrapper-num-l>div:last-child{margin-top: 0.2rem;}
.public-wrapper-num-r{border-left: 1px solid #ebedf0;padding-left: 0.2rem;}
.total-ordernum{padding: 0.3rem 0.2rem;margin-top: 0.95rem;}
.total-ordernum p{font-size: 0.26rem;color: #999;}
.total-ordernum p strong{font-size: 0.28rem;color: #333;}
.total-ordernum p span{float: right;font-size: 0.26rem;}
.total-ordernum p span i{font-size: 0.26rem;}
.invite-list{padding: 0 0.2rem;}
.invite-item{background-color: #fff;padding: 0.3rem 0.2rem;border-radius: 5px;display: flex;align-items: center;position: relative;}
.invite-item .pictrue{width: 0.72rem;height: 0.72rem;border-radius: 50%;overflow: hidden;}
.invite-item .pictrue img{width: 100%;}
.invite-item .text{margin-left: 0.2rem;}
.invite-item .text p{color: #999;font-size: 0.26rem;margin-top: 0.1rem;}
.invite-item .text p strong{color: #333;font-size: 0.28rem;}
.invite-item .text .name{font-size: 0.28rem;}
.invite-item .right{position: absolute;right: 0.2rem;color: #969799;}
.no-customer img{display: block;width: 50%;margin: 0 auto;margin-top: 50%;}
.no-customer p{text-align: center;color: #999;margin-top: 0.2rem;}
</style>
